import { NewSpaceGate, NewSpaceGateInput } from 'utils/new-space-gate-types';

export const CEILING_HEIGHT_REQUIRED_REASON = 'Floor ceiling height required';
export const FLOOR_FULLY_COVERED_REASON =
  'No room left on this floor — resize or delete an existing space to make room.';

function resolveNewSpaceGateReason({
  isConditioned,
  hasCeilingHeight,
  isFloorFullyCovered
}: NewSpaceGateInput): string | undefined {
  if (isConditioned && !hasCeilingHeight) {
    return CEILING_HEIGHT_REQUIRED_REASON;
  }
  if (isFloorFullyCovered) {
    return FLOOR_FULLY_COVERED_REASON;
  }
  return undefined;
}

export function resolveNewSpaceGate(input: NewSpaceGateInput): NewSpaceGate {
  const { loading, isConditioned, hasCeilingHeight, isFloorFullyCovered } =
    input;
  return {
    isBlocked:
      loading || (isConditioned && !hasCeilingHeight) || isFloorFullyCovered,
    isFloorFullyCovered,
    reason: resolveNewSpaceGateReason(input)
  };
}
